<template>
  <div class="employeeManager">
    <h2>{{ $t('label.titleEmployeeManager') }}</h2>

    <!-- ===== SEARCH BAR ===== -->
    <div class="d-flex mb-2 flex-wrap align-items-center">
      <span class="mr-2 font-bold">
        Tìm kiếm theo ID
      </span>

      <b-form-input v-model.number="searchId" type="number" min="1" placeholder="Nhập ID nhân viên"
        style="max-width:260px" @keyup.enter="searchById" @input="!searchId && resetSearch()" />

      <b-button variant="primary  " class="ml-2" @click="searchById">
        Tìm kiếm
      </b-button>

      <b-button class="ml-2 mt-2 mt-md-0" variant="outline-success" @click="resetSearch()">
        <i class="fa fa-refresh mr-1"></i>
        Đặt lại
      </b-button>

      <b-button class="ml-auto mt-2 mt-md-0" variant="outline-success" @click="loadAddNew">
        <i class="fa fa-plus"></i>
        {{ $t('label.addNewEmployee') }}
      </b-button>
    </div>

    <!-- ===== TABLE ===== -->
    <b-table bordered hover head-variant="dark" :items="dataTable" :fields="fields" responsive>
      <template #cell(action)="data">
        <a href="#" @click.prevent="editUser(data.item.id)">
          {{ $t('label.edit') }}
        </a>
        |
        <a href="#" @click.prevent="openDeleteUserModal(data.item.id)">
          {{ $t('label.delete') }}
        </a>
      </template>
    </b-table>

    <div v-if="dataTable.length === 0" class="text-center text-muted mt-3">
      Không có dữ liệu
    </div>

    <div class="d-flex justify-content-between mt-3 flex-wrap">
      <small class="text-muted">
        Hiển thị
        {{ (currentPage - 1) * perPage + 1 }}
        –
        {{ Math.min(currentPage * perPage, totalElements) }}
        /
        {{ totalElements }}
        bản ghi
      </small>

      <div class="d-flex">
        <b-form-select size="sm" v-model="selectedPerPage" :options="optionsPages" class="mr-2" style="max-width:100px"
          @change="changePerPage" />
        <b-pagination v-model="currentPage" :total-rows="totalElements" :per-page="perPage" size="sm"
          @change="changePage" />
      </div>
    </div>

    <!-- ===== ADD MODAL ===== -->
    <b-modal ref="modal-add" size="lg" hide-footer>
      <template #modal-header>
        <h5>{{ $t('label.addNewEmployee') }}</h5>
      </template>

      <div class="row">
        <div class="col-md-6">
          <label class="require">{{ $t('label.username') }}</label>
          <b-form-input v-model="userNew.username" />
          <div class="error">{{ msg.username?.[0] }}</div>

          <label class="require mt-2">{{ $t('label.status') }}</label>
          <b-form-select v-model="userNew.status" :options="optionsStatus" />
        </div>

        <div class="col-md-6">
          <label class="require">{{ $t('label.password') }}</label>
          <b-form-input type="password" v-model="userNew.password" />

          <label class="require mt-2">{{ $t('label.name') }}</label>
          <b-form-input v-model="userNew.fullName" />
        </div>
      </div>

      <div class="text-center mt-3">
        <b-button size="sm" variant="danger" @click="cancel">
          {{ $t('label.cancel') }}
        </b-button>
        <b-button size="sm" variant="success" class="ml-2" @click="insertEmployee">
          {{ $t('label.save') }}
        </b-button>
      </div>
    </b-modal>

    <!-- ===== EDIT MODAL ===== -->
    <b-modal ref="modal-edit" size="lg" hide-footer>
      <template #modal-header>
        <h5>{{ $t('label.edit') }}</h5>
      </template>

      <div class="row">
        <div class="col-md-6">
          <label>{{ $t('label.username') }}</label>
          <b-form-input disabled v-model="updateUser.username" />

          <label class="mt-2">{{ $t('label.status') }}</label>
          <b-form-select v-model="updateUser.status" :options="optionsStatus" />
        </div>

        <div class="col-md-6">
          <label>{{ $t('label.password') }}</label>
          <b-form-input type="password" v-model="updateUser.password" />

          <label class="mt-2">{{ $t('label.name') }}</label>
          <b-form-input v-model="updateUser.fullName" />
        </div>
      </div>

      <div class="text-center mt-3">
        <b-button size="sm" variant="danger" @click="cancel">
          {{ $t('label.cancel') }}
        </b-button>
        <b-button size="sm" variant="success" class="ml-2" @click="updateEmployee">
          {{ $t('label.save') }}
        </b-button>
      </div>
    </b-modal>

    <!-- ===== DELETE MODAL ===== -->
    <b-modal ref="modal-delete" hide-footer>
      <template #modal-header>
        <h5>{{ $t('label.deleteSaleTitle') }}</h5>
      </template>

      <div class="text-center">
        <b-button size="sm" variant="danger" @click="cancelDelete">
          {{ $t('label.cancel') }}
        </b-button>
        <b-button size="sm" variant="success" class="ml-2" @click="deleteSale">
          {{ $t('label.delete') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      searchId: null,
      msg: {},

      fields: [
        { key: 'id', label: this.$t('label.id') },
        { key: 'fullName', label: this.$t('label.nameEmployee') },
        {
          key: 'status',
          label: this.$t('label.status'),
          formatter: v =>
            v === 1
              ? this.$t('label.active')
              : this.$t('label.noActive')
        },
        { key: 'action', label: 'Quản lý' }
      ],

      dataTable: [],
      currentPage: 1,
      perPage: this.$perPage,
      selectedPerPage: this.$perPage,
      totalElements: 0,
      optionsPages: this.$paginationPages,

      optionsStatus: [
        { value: -1, text: this.$t('label.chooseStatus') },
        { value: 0, text: this.$t('label.noActive') },
        { value: 1, text: this.$t('label.active') }
      ],

      userNew: {
        username: '',
        password: '',
        fullName: '',
        status: -1
      },

      updateUser: {
        user_id: null,
        username: '',
        password: '',
        fullName: '',
        status: -1
      },

      selectedUserId: null
    }
  },

  mounted() {
    this.getListUserSale()
  },

  methods: {
    async searchById() {
      if (!this.searchId) return

      try {
        const res = await apiClient.get('/api/v1/admin/sale/' + this.searchId)

        const item = Array.isArray(res.data) ? res.data[0] : res.data

        if (item) {
          this.dataTable = [{
            ...item,
            fullName: item.full_name
          }]
          this.totalElements = 1
          this.currentPage = 1
        } else {
          this.dataTable = []
          this.totalElements = 0
        }
      } catch (e) {
        this.dataTable = []
        this.totalElements = 0
        this.$bvToast.toast('Không tìm thấy nhân viên', {
          variant: 'warning',
          solid: true
        })
      }
    },

    resetSearch() {
      this.searchId = null
      this.currentPage = 1
      this.getListUserSale()
    },

    async getListUserSale() {
      const res = await apiClient.post('/api/v1/admin/sale/list', {
        role_id: 2,
        pageIndex: this.currentPage,
        pageSize: this.perPage
      })

      if (res?.data) {
        this.dataTable = res.data.items
        this.totalElements = Number(res.data.total)
        this.currentPage = res.data.pageIndex
      }
    },

    changePage(page) {
      this.currentPage = page
      this.getListUserSale()
    },

    changePerPage() {
      this.perPage = this.selectedPerPage
      this.currentPage = 1
      this.getListUserSale()
    },

    loadAddNew() {
      this.$refs['modal-add'].show()
    },

    async insertEmployee() {
      try {
        await apiClient.post('/api/v1/admin/sale/create', this.userNew)
        this.$bvToast.toast('Thêm nhân viên thành công!', {
          title: 'Thành công',
          toaster: 'b-toaster-top-right',
          variant: 'success',
          solid: true
        })
        this.cancel()
        this.getListUserSale()
      } catch (e) {
        this.msg = e.response?.data || {}
      }
    },

    async editUser(id) {
      this.$refs['modal-edit'].show()
      const res = await apiClient.get('/api/v1/admin/sale/' + id)
      if (res?.data?.[0]) {
        Object.assign(this.updateUser, {
          user_id: res.data[0].id,
          username: res.data[0].username,
          fullName: res.data[0].full_name,
          status: res.data[0].status
        })
      }
    },

    async updateEmployee() {
      await apiClient.post('/api/v1/admin/sale/update', this.updateUser)
      this.$bvToast.toast('Cập nhật thành công!', {
        title: 'Thành công',
        toaster: 'b-toaster-top-right',
        variant: 'success',
        solid: true
      })
      this.cancel()
      this.getListUserSale()
    },

    openDeleteUserModal(id) {
      this.selectedUserId = id
      this.$refs['modal-delete'].show()
    },

    cancelDelete() {
      this.$refs['modal-delete'].hide()
    },

    async deleteSale() {
      await apiClient.put('/api/v1/admin/sale/delete/' + this.selectedUserId)
      this.cancelDelete()
      this.getListUserSale()
      this.$bvToast.toast('Xóa nhân viên thành công!', {
        title: 'Thành công',
        toaster: 'b-toaster-top-right',
        variant: 'success',
        solid: true
      })
    },

    cancel() {
      this.$refs['modal-add'].hide()
      this.$refs['modal-edit'].hide()
      this.msg = {}
      this.userNew = { username: '', password: '', fullName: '', status: -1 }
    },
  }
}
</script>

<style scoped>
.employeeManager a {
  color: #0d6efd;
  cursor: pointer;
}

.error {
  color: red;
  font-size: 12px;
}
</style>
